(function () {
	'use strict';

	angular
		.module('invesfleet')
        .factory('restrictionService', restrictionService);

    restrictionService.$inject = ['$http', '$q', 'userService', '$state', 'notificationService', 'endPoints', 'authorization'];

    function restrictionService($http, $q, userService, $state, notificationService, endPoints, authorization) {

        //getEntidadesPersonalized(); 

        var inUse = null; 

        var service = {
            hasPermission: hasPermission, 
        };

		return service;

        
        function hasPermission(type, name, state, params) {

            var go = state != null && state != undefined;
            var idx = userService.userData.restrictions.findIndex(x => x.entidad == name);
            if (idx != -1 && (((userService.userData.restrictions[idx].tipo & type) == type))) {
                sendErrorRequire("No tiene los permisos adecuados, consulte con el administrador!");
                return false; 
            } 
            else {
                if(go) {
                    $state.go(state, params);
                }
                else return true; 
               
            }
        }

        function sendErrorRequire(msg) {
            notificationService.sendAppNotification({
                message: msg,
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

	}

})();